// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SimpleModelOutlinedSvg from "@fishx/icons-svg/es/asn/SimpleModelOutlined";
import FishxIcon from '../components/FishxIcon';

var SimpleModelOutlined = function SimpleModelOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SimpleModelOutlinedSvg
  }));
};

SimpleModelOutlined.displayName = 'SimpleModelOutlined';
export default React.forwardRef(SimpleModelOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SimpleModelOutlined.js
// module id = 4122
// module chunks = 0